import { Message, Loading } from 'dygc-ui'
import { mapGetters } from 'vuex'
import {
  getSurveyGroups,
  setSurveyGroupName,
  deleteSurveyGroup,
  modifySurveyGroup,
  modifyWJGroup,
  getWJCoordUserList,
  getWJCoordLinkList
} from '@/api/wenjuan/wjquestion.js'
import {
  getQuestionList,
  copyWj,
  createWj,
  addOrDelStart,
  updateWj,
  deleteWj,
  getSharePersonList,
  updateSharedPerson,
  closeAllWj,
  getSurveysBack,
  wjSceneTypeListAll
} from '@/api/wenjuan/wjquestion.js'
import {getMcafList, deleteMcafPro, getMcafUrl, updataMcaf} from '@/api/mcaf.js'
import { tableOption, column1, surveyIdOption, column2, recycleOption, mcafColumn } from './wjquestion'
import { getRecycleList } from '@/api/wenjuan/recycle.js'
import { getStore, setStore } from '@dygc/shared'
import intersection from 'lodash.intersection'
import isEqual from 'lodash.isequal'
import sortby from 'lodash.sortby'
import difference from 'lodash.difference'
import GlobalConfig from '@/global/config'
import { SURVEY_PUBLISH_STATUS } from '@/global/config-variable'
import { PAGE_TYPE } from '../variable'
import { previewSurvey } from '@/assets/js/base-platform'
import Status from '@/components/base/Status.vue'

import { publishWJMixins } from '@/mixins/publish'
import ClickDelete from '@/components/PopConfirm.vue'
import CoordManageDialog from './CoordManageDialog'
import ShareCoordDialog from './ShareCoordDialog'
import DygcFooter from 'components/dygc-footer-bottom/index'
import { batchDeleteWj, openAllWj, getSurveyPreview, getVersionAllSimple } from '@/api/wenjuan/wjquestion.js'
import sensitiveDialog from '@/components/dialog/sensitiveDialog'
import { getSurveyById } from '@/api/survey'
import { SurveyScene }  from '@/assets/js/config/survey-config'
import { redirectUtil, replaceText } from '@/assets/js/utils'
import { copyText } from '@dygc/shared'
import { getSurveyDomain } from '@/assets/js/config/env'
export default {
  mixins: [publishWJMixins],
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  filters: {
    auditStatus(val) {
      if (val === 0) {
        return '审核中'
      } else if (val === 2) {
        return '审核拒绝'
      } else {
        return ''
      }
    },
  },
  components: { Status, ClickDelete, sensitiveDialog, CoordManageDialog, ShareCoordDialog, DygcFooter },
  data() {
    return {
      codeSrc: process.env.VUE_APP_OFFICIAL_ACCOUNT_QR_CODE,
      groupId: '', //新版本暂时只显示全部
      wjName: '',
      surveyGroups: [],
      formInline: {
        date: [],
        publishStatus: '',
        status:null,
        isStar: '',
        type: '',
        complex: '',
        id: '',
        title:'',
        sceneType: ''
      },
      pagination: {
        total: 0, // 总页数
        current: 1, // 当前页数
        size: 20, // 每页显示多少条
      },
      tableData: [],
      tableList: [],
      tableLoading: false,
      tableOption,
      column1,
      surveyIdOption,
      column2,
      sortParams: {
        descs: ['is_star', 'create_time']
      },
      mcafSort:{sortField:'createdAt',desc:true},
      closeVisible: false, // 关闭问卷提示框的显隐,
      headerRowStyle: { height: '45px' },
      sharedPerson: [], // 已共享的人
      sharedPersonBak: [], // 已共享的人 备份
      allSharePerson: [], // 当前未共享的人
      transferVisible: false, //控制穿梭框
      wjId: '', // 弹层中保存问卷id
      isEqual,
      sortby,
      shareRadio: '1',

      //回收站
      selectedItems: [], //多选表格选中数组
      recycleOption,
      mcafColumn,
      PAGE_TYPE,
      SURVEY_PUBLISH_STATUS,

      fromAdd: false, // 为了 区分 返回的情况
      closewjId: '',
      tableScrollTop: 0,
      timer: null,
      checkAll: false, //是否全选
      // isAll: false,
      showCoordManage: false,
      showCoordShare: false,
      questionId: '',
      activeCard: 'user',
      currentLevelId: '',
      companyUser: null,

      sensitiveData: {},
      sensitiveShow: false,
      lastReleaseVersion: {},
      historyVersions: [],
      lastDraftVersion: {},
      openCloseVisible: false,
      projectListData: [],
      scene: 'Default',
      longPressTimer: null
    }
  },
  computed: {
    showDygcFooter() {
      let config = this.$store.getters.configContextMap.get('home')?.out_D19_1
      return config ? config === "1" : true
    },
    companyId() {
      return GlobalConfig.getCompanyId()
    },
    tableOptionNew() {
      if (this.page != this.PAGE_TYPE.RECYCLED) {
        this.tableOption.column = []
        if(this.page == this.PAGE_TYPE.MCAF){
          this.tableOption.column.push(...this.mcafColumn)
        }else{
          this.tableOption.column.push(...this.column1, ...this.surveyIdOption, ...this.column2)
        }
        return this.tableOption
      }else {
        //回收站的表格option
        return recycleOption
      }
    },
    baseUrl() {
      return getSurveyDomain()
    },
    // 获取 用户名
    getUserName() {
      return function (row) {
        if (row.createBy.indexOf('〒') !== -1) {
          return row.createBy.split('〒')[0]
        } else {
          return row.createBy
        }
      }
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    getParams() {
      this.formInline.isStar = this.page === this.PAGE_TYPE.COLLECTION ? this.PAGE_TYPE.COLLECTION : this.formInline.isStar
      return Object.assign({}, this.sortParams, {
        id: this.formInline.id, // 问卷ID
        publishStatus: this.formInline.publishStatus,
        sceneType: this.formInline.sceneType === 0 ? '0': this.formInline.sceneType,
        isStar: this.formInline.isStar, // 0 否 1是
        groupId: this.groupId,
        current: this.pagination.current,
        size: this.pagination.size,
        params: {
          beginUpdateTime: (this.formInline.date && this.formInline.date[0]) || '',
          endUpdateTime: (this.formInline.date && this.formInline.date[1]) || '',
          authType:
            this.page == this.PAGE_TYPE.COOPERATION
              ? this.PAGE_TYPE.CREATED
              : this.page == this.PAGE_TYPE.CREATED
              ? this.PAGE_TYPE.COLLECTION
              : '',
          complex: this.formInline.complex
        }
      })
    },
    getParamsRecycle() {
      return Object.assign({}, this.sortParams, {
        current: this.pagination.current,
        size: this.pagination.size,
        publishStatus: this.formInline.publishStatus,
        isStar: this.formInline.isStar, // 0 否 1是
        id: this.formInline.id,
        params: {
          beginDelTime: (this.formInline.date && this.formInline.date[0]) || '',
          endDelTime: (this.formInline.date && this.formInline.date[1]) || '',
          authType: this.formInline.type
        }
      })
    },
    getMacfParams() {
      return Object.assign({}, this.mcafSort, {
        page: this.pagination.current-1,
        size: this.pagination.size,
        status: this.formInline.status,
        id: this.formInline.id,
        title:this.formInline.title,
        begin: (this.formInline.date && this.formInline.date[0]) || '',
        end: (this.formInline.date && this.formInline.date[1]?.replace('00:00:00','23:59:59')) || '',
        createdBy: this.formInline.complex,
        type:3,  //1 我收藏的 2我创建的 3我参与的 4 我删除的
        token:GlobalConfig.getBaseToken()
      })
    },
    selectedAll() {
      console.log('selectedAll')
      return this.selectedItems.length === this.pagination.total
    },
    isAll: {
      get() {
        return this.selectedAll || this.checkAll
      },
      set(val) {

      }
    }
  },
  watch: {
    showCoordManage(bool) {
      if (!bool) {
        this.$store.commit('SET_SURVEY_TITLE', { title: '', titlex: '' })
        this.questionId = ''
        this.activeCard = 'user'
      }
    },
    showCoordShare(bool) {
      if (!bool) {
        this.$store.commit('SET_SURVEY_TITLE', { title: '', titlex: '' })
        this.questionId = ''
        this.activeCard = 'user'
      }
    }
  },
  mounted() {
    this.watchTableTop() //监听表格组件的滚动
    this.initList()
    this.initSurveyGroups();
    this.getProjectListData();
  },
  methods: {
    popoverTitle(val) {
      if(this.page == this.PAGE_TYPE.MCAF){
        if(val===0){
          return '提示'
        }else if(val===1){
          return '关闭明察暗访'
        }else {
          return ''
        }
      }
      if (val === SURVEY_PUBLISH_STATUS.UNPUBLISHED) {
        // 状态为未发布 对应按钮为发布
        return ''
      } else if (val === SURVEY_PUBLISH_STATUS.RECYCLING) {
        // 状态为回收中 对应按钮为关闭
        return '关闭问卷'
      } else if (val === SURVEY_PUBLISH_STATUS.CLOSED) {
        // 状态为关闭 对应按钮为开启
        return '提示'
      }
    },
    copySurveyId(surveyId) {
      copyText('.wjId_' + surveyId, surveyId)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
    },
    startLongPress(row) {
      clearTimeout(this.longPressTimer);
      this.longPressTimer = 0
      this.longPressTimer = setTimeout(() => {
        this.longPressTimer = 1
        copyText('.name_title_'+row.id, row.title)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(() => {
          this.$message.error('复制失败')
        })
      }, 500)
    },
    oneClickTitle(row) {
      this.page != this.PAGE_TYPE.RECYCLED && this.page != this.PAGE_TYPE.MCAF ? this.goSurveyLink(row) : ''
    },
    cancelLongPress(row) {
      if(this.longPressTimer !== 1) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = 0
        this.oneClickTitle(row)
      }
    },
    watchTableTop() {
      this.$nextTick(() => {
        const dom = this.$refs.tabelContent?.bodyWrapper
        const change = () => {
          if (dom) {
            this.tableScrollTop = dom.scrollTop ?? 0
          }
        }
        // fix 选择创建方式 页面报错
        if(!dom) return
        dom.addEventListener('scroll', handleScroll(change))
      })
      //节流
      const handleScroll = fun => {
        let timer
        return function () {
          if (timer) return
          timer = setTimeout(() => {
            fun()
            timer = null
          }, 500)
        }
      }
    },
    initList() {
      if (localStorage.getItem('wj_list_history')) {
        const savedData = JSON.parse(localStorage.getItem('wj_list_history'))
        //问卷列表存的查询数据不为空 && 是当前登录人 && 是当前登录公司 && 是当前页面
        if (
          savedData.username === this.userInfo.username &&
          this.companyId === savedData.companyId &&
          this.page === savedData.pageType
        ) {
          //查询列表输入框内的反显处理
          this.formInline = {
            date: [savedData.searchParams.params.beginUpdateTime || '', savedData.searchParams.params.endUpdateTime || ''],
            publishStatus: savedData.searchParams.publishStatus,
            status: savedData.searchParams.status,
            isStar: savedData.searchParams.isStar,
            complex: savedData.searchParams.params.complex,
            id: savedData.searchParams.id,
            title: savedData.searchParams.title
          }
          this.getList(savedData)
        } else {
          this.getList()
        }
      } else {
        this.getList()
      }
    },
    // el-table 修改第一列的左边距为16px
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return `padding-left:16px;`
      } else {
        return ''
      }
    },
    headerCellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0 && rowIndex === 0) {
        return `padding-left:16px;`
      } else {
        return 'padding: 0; height: 45px;'
      }
    },
    getExtra(v, internalShare) {
      v.name = v.name === 'null' ? null : v.name
      v.phone = v.phone === 'null' ? null : v.phone
      if (v.showCreate) {
        return `${v.name??''}${v.name && v.phone ?'-':''}${v.phone??''}` + ' 创建问卷'
      } else if (internalShare === true) {
        return `${v.name??''}${v.name && v.phone ?'-':''}${v.phone??''}` + ' 分享协作'
      } else if (internalShare === false) {
        return `${v.name?v.name.charAt():''}**-${v.phone?v.phone.substring(0, 3):''}****${v.phone?v.phone.substring(7):''}` + ' 分享协作'
      } else if (internalShare === null) {
        return ''
      }
    },
    /**
     *
     * @param {String} v
     * @param {Boolean} internalShare 是否为 内外部分享 内部分享正常显示 外部分享脱敏显示
     * @returns
     */
    getCreateBy(v, internalShare) {
      const res = Array.from(new Set(v.split('〒').reverse()))
        .slice(0, 3)
        .reverse()
        .filter(item => item)
      if (internalShare === true) {
        return res.join('-')
      } else if (internalShare === false) {
        const resArr = []
        res.forEach((element, index) => {
          if (index === 0) {
            element = `${element.charAt()}**`
          } else if (index === 1) {
            element = `${element.substring(0, 3)}****${element.substring(7)}`
          }
          resArr.push(element)
        })
        return resArr.join('-')
      } else {
        return res.join('-')
      }
    },
    // 回收站-批量还原
    restore() {
      if (this.selectedItems.length === 0) {
        this.$message.error('请选择需要还原的问卷')
      } else {
        // 拼接参数
        let ids = this.selectedItems.map(item => {
          return item.id
        })
        if(this.isAll) {
          ids = []
        }
        getSurveysBack({
          selectedIds: ids,
          query: this.getParamsRecycle
        })
          .then(res => {
            if (res.data.code === 0) {
              this.$message.success('还原问卷成功')
              this.selectedItems = []
              this.getList()
              this.clearSelection()
            } else {
              this.$message.warning(res.data.msg || res.data.data)
            }
          })
          .catch(() => {
            this.$message.error('还原问卷失败')
          })
      }
    },
    /* ------处理多选表格切换分页保留选项(”回收站“(page=='4')部分涉及)  --start-- */
    //表格选中事件（选中的数组，操作行）
    select(selection, row) {
      //如果选中的数组中存在当前操作行，则为添加
      // if (selection.find(item => item?.id == row.id)) {
      //   this.addSelectedItem([row]);
      // } else { // 否则为删除
      //   this.delSelectedItem([row]);
      // }
      this.selectedItems = selection.slice()
      this.checkAll = this.selectedItems.length === this.pagination.total
    },
    //表格全选事件
    selectAll(selection) {
      this.selectedItems = selection.slice()
      // this.isAll = this.selectedItems.length === this.pagination.total
      // if (selection.length) {
      //   this.addSelectedItem(this.tableData);
      // } else {
      //   this.delSelectedItem(this.tableData);
      // }
    },
    // addSelectedItem(rows) {
    //   rows.forEach(item => {
    //     if (this.selectedItems.findIndex(ele => ele.id == item.id) != -1) {
    //       return;
    //     };
    //     this.selectedItems.push(item);
    //   });
    // },
    // delSelectedItem(rows) {
    //   if (this.selectedItems.length == 0) {
    //     return;
    //   }
    //   rows.forEach(item => {
    //     this.selectedItems = this.selectedItems.filter(ele => {
    //       return ele.id != item.id;
    //     })
    //   });
    // },
    //在表格中勾选选中数据
    // handleSelected(rows) {
    //   if (rows.length) {
    //     this.$nextTick(() => {
    //       rows.forEach(row => {
    //         let selectedItem = this.tableData.find(item => item.id == row.id);
    //         this.$refs.tabelContent?.toggleRowSelection(selectedItem);
    //       });
    //     })
    //   } else {
    //     this.clearSelection();
    //   }
    // },
    clearSelection() {
      this.$refs.tabelContent?.clearSelection()
      this.selectedItems = []
    },
    /* ------处理多选表格切换分页保留选项  --end-- */

    // 空数据时--按钮事件 去 '全部' 列表
    toAllList() {
      this.$router.push({
        path: '/project/all'
      })
    },
    // 添加项目 按钮
    onClickCreateWj() {
      // this.$router.push({
      //   path: '/create-survey'
      // })
      this.$router.push({
        path: '/create-scene'
      })
    },
    debounceCreate(fn) {
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(fn, 500)
    },
    //添加问卷
    onClickCreate() {
      // 控制 全部以外的 添加问卷
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let gId = this.groupId;
      const titlex = replaceText('请填写问卷标题',this.$route.query.scene, this.$route.query.scene==='Satisfaction'?1:0)
      createWj(this.wjName || titlex, gId, SurveyScene[this.$route.query.scene] )
        .then(res => {
          let id = res.data.data.id
          // updateWj({
          //   id,
          //   title: '请填写问卷调查标题',
          //   welcome: '',
          //   titlex: '请填写问卷调查标题'
          // }).then(res => {
          this.fromAdd = true
          this.jumpUrl(id,`/edit?scene=${this.$route.query.scene}`)
          // })
        })
        .catch(err => {})
        .finally(() => {
          loading.close()
        })
    },
    // 问卷功能--取消标星
    closeStart(row) {
      addOrDelStart({ id: row.id, isStar: 0 })
        .then(res => {
          row.isStar = 0
          this.getList()
        })
        .catch(err => {
          this.$message.error('操作失败，稍后重试')
        })
    },
    addStart(row) {
      addOrDelStart({ id: row.id, isStar: 1 })
        .then(res => {
          row.isStar = 1
          this.getList()
        })
        .catch(err => {
          this.$message.error('操作失败，稍后重试')
        })
    },
    // 问卷功能--编辑
    editMethod(row) {
      console.log('row', row)
      setStore({ name: 'shareWjAccess', content: row.shareWjAccess ? row.shareWjAccess.map(it => it.value) : null })
      this.jumpUrl(row.id,`/edit?scene=${row.sceneValue}`)
    },
    // 问卷功能--删除
    delMethod(row) {
      // this.$confirm(`问卷《${row.title}》删除后将被移入回收站，可到回收站还原。`, '问卷删除', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     deleteWj(row.id).then(res => {
      //       this.$message({
      //         type: 'success',
      //         message: '删除成功!'
      //       })
      //       this.getList()
      //     })
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: 'info',
      //       message: '已取消删除'
      //     })
      //   })
      deleteWj(row.id).then(res => {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.getList()
      })
    },
    // 问卷确认关闭
    sureClose(scope) {
      closeAllWj(new Array(this.closewjId))
        .then(res => {
          if (res.status == 200) {
            this.$message.success('关闭成功')
          }
          // this.closeVisible = false
          this.$refs[`popover-${scope.$index}`].doClose()
          this.getList()
        })
        .catch(e => {
          this.$message.error('关闭失败')
          throw new Error(e)
        })
    },
    // 问卷功能--去往数据
    recycleList(row) {
      setStore({ name: 'shareWjAccess', content: row.shareWjAccess ? row.shareWjAccess.map(it => it.value) : null })
      this.jumpUrl(row.id, `/data/data-download?scene=${row.sceneValue}`)
    },
    // 问卷功能--dropdown的方法调度
    onChangeCommand(params, scope) {
      if (params) this[params](scope.row)
    },
    // 问卷功能--预览
    preMethod(row) {
      //新打开页面预览
      // const { href } = this.$router.resolve({
      //   path: `${this.baseUrl}#/previewTest?id=${row.id}&token=${GlobalConfig.getBaseToken()}`,
      // });
      let params = { id: row.id }
      previewSurvey(params)
    },
    // 问卷功能--分享协作
    // shareQuestionnaire(row) {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(0, 0, 0, 0.7)'
    //   })
    //   if (!this.companyId) {
    //     this.$message.error('个人用户暂不支持共享')
    //     return
    //   }
    //   this.wjId = row.id
    //   // 获取全部人
    //   getSharePersonList({ id: row.id })
    //     .then(res => {
    //       const p = res.data.data || []
    //       this.sharedPerson = []
    //       this.sharedPersonBak = []
    //       // 整理选中的人员
    //       p.forEach(item => {
    //         if (item.shared) {
    //           const user = item.user
    //           if (!this.sharedPerson.includes(user.staffId)) this.sharedPerson.push(user.staffId)
    //         }
    //       })
    //       // 备份
    //       this.sharedPersonBak = JSON.parse(JSON.stringify(this.sharedPerson))
    //       //过滤掉子账号(子账号mobile为null)
    //       const _p = p.filter(({ user }) => user.mobile)
    //       // 获取全部分享的人
    //       this.allSharePerson = _p.map((item, idx) => {
    //         const user = item.user
    //         return {
    //           // label: user.userId + '-' + user.mobile + '-' + user.name,
    //           label: user.name + '-' + user.mobile,
    //           key: user.staffId, // 用于分享选人时使用
    //           disabled: false,
    //           shared: item.shared
    //         }
    //       })
    //       this.transferVisible = true
    //     })
    //     .catch(() => {})
    //     .finally(() => {
    //       loading.close()
    //     })
    // },
    // 问卷功能--新分享协作
    shareQuestionnaire(row) {
      if (row.sizeLoading) {
        return
      }
      const params = {
        size: 1,
        current: 1,
        wjId: row.id
      }
      const pmList = [getWJCoordUserList(params), getWJCoordLinkList(params)]
      this.$set(row, 'sizeLoading', true)
      Promise.all(pmList)
        .then(([userRes, linkRes]) => {
          const { code: uCode, msg: uMsg, data: uData } = userRes.data || {}
          const { code: lCode, msg: lMsg, data: lData } = linkRes.data || {}
          if (uCode === 0 && lCode === 0) {
            const uList = uData?.records || []
            const lList = lData?.records || []
            if (uList.length > 0 || lList.length > 0) {
              if (uList.length > 0) {
                this.activeCard = 'user'
              } else if (lList.length > 0) {
                this.activeCard = 'link'
              }
              this.scene = row.sceneValue;
              this.showCoordManage = true
            } else {
              this.scene = row.sceneValue;
              this.showCoordShare = true
            }
            this.questionId = row.id
            this.$store.commit('SET_SURVEY_TITLE', { title: row.title ?? '', titlex: row.titlex ?? '' })
          } else {
            this.$message.error(uMsg ?? lMsg ?? '初始化协作分享失败')
          }
        })
        .catch(() => {
          this.$message.error('初始化协作分享失败')
        })
        .finally(() => {
          this.$set(row, 'sizeLoading', false)
        })
    },
    // 确定
    confirmShares() {
      const same = intersection(this.sharedPersonBak, this.sharedPerson)
      const dif_remove = difference(this.sharedPersonBak, same)
      const dif_add = difference(this.sharedPerson, same)
      let p1, p2
      if (dif_add.length > 0) {
        p1 = updateSharedPerson({
          wjId: this.wjId,
          userIds: dif_add.join(','),
          flag: 1
        })
      }
      if (dif_remove.length > 0) {
        p2 = updateSharedPerson({
          wjId: this.wjId,
          userIds: dif_remove.join(','),
          flag: 2 // 1 以外是删除
        })
      }
      let p = []
      p1 && p.push(p1)
      p2 && p.push(p2)
      Promise.all(p)
        .then(res => {
          this.$message.success('共享成功')
          this.transferVisible = false
        })
        .catch(e => {
          this.$message.error('共享失败，请重试')
        })
    },
    // 取消
    cancelShares() {
      this.transferVisible = false
      // 恢复之前选中的结果
      this.sharedPerson = this.sharedPersonBak
    },
    // 关闭共享弹层
    closeShareDialog() {
      this.wjId = ''
    },
    // 问卷功能--复制
    onClickCopy(type, id) {
      const loading = {
        loadingInstance: null,
        open: function () {
          if (this.loadingInstance === null) {
            this.loadingInstance = Loading.service({
              text: '正在复制中',
              target: '.main',
              background: 'rgba(0, 0, 0, 0.5)'
            })
          }
        },
        close: function () {
          if (this.loadingInstance !== null) {
            this.loadingInstance.close()
          }
          this.loadingInstance = null
        }
      }
      loading.open()

      // 控制 全部以外的 复制
      let gId = { type, groupId: this.groupId }
      copyWj(id, gId)
        .then(res => {
          this.getList()
        })
        .catch(err => {
          this.$message.error('复制失败，稍后重试')
        })
        .finally(() => {
          loading.close()
        })
    },
    // 问卷功能--更改分组
    onClickMove(groupId, id) {
      // 未分组 groupId 0 ; 全部 ''
      const p = {
        surveyId: id
      }
      if (groupId !== undefined || groupId !== '') {
        p.groupId = groupId
      }
      // 未分组 删除参数
      if (groupId === 0) {
        delete p.groupId
      }
      modifyWJGroup(p)
        .then(res => {
          this.$message.success('移动成功')
          this.getList()
        })
        .catch(err => {
          this.$message.error('移动失败，稍后重试')
        })
    },
    //路由跳转到 编辑规则设置发布数据分析
    jumpUrl(id, path = '/edit') {
      if (this.fromAdd) {
        // 选模版是页面，导致返回错误。临时用变量判断
        this.$router.push(`/survey/${id}${path}`)
      } else {
        this.$router.cachePush(`/survey/${id}${path}`)
      }
    },
    commonChange() {
      if (this.page == this.PAGE_TYPE.RECYCLED) {
        //回收站
        this.getList()
      }
    },
    //重置按钮
    onReset() {
      this.formInline = {
        date: [],
        publishStatus: '',
        status:null,
        isStar: '',
        type: '',
        complex: '',
        id: '',
        title:'',
      }
      this.toSearch()
    },
    toSearch() {
      this.pagination.current = 1
      this.getList()
      // this.handleTableScrollTop()
    },
    clearEmptyData(data) {
      for (let k in data) {
        if (!data[k] || data[k] === 0) {
          delete data[k]
        } else if (Object.prototype.toString.call(data[k]) == '[object Object]') {
          this.clearEmptyData(data[k])
        }
      }
    },
    clearEmptyMcafData(data) {
      for (let k in data) {
        if (data[k]===null || data[k]==='') {
          delete data[k]
        }
      }
    },
    // 排序
    compare(property,type) {
      const proList={create_time:'createTime',update_time:'updateTime',is_star:'isStar',answerRecoveryAmount:'answerRecoveryAmount'};
      const pro=proList[property]
      return function (a, b) {
        if(type=='descs'){
          if(property=='create_time' || property=='update_time'){
            return new Date(b[pro]).getTime() - new Date(a[pro]).getTime();
          }else{
            return b[pro] - a[pro];
          }
        }else{
          if(property=='create_time' || property=='update_time'){
            return new Date(a[pro]).getTime() - new Date(b[pro]).getTime();
          }else{
          return a[pro] - b[pro];
          }
        }
      }
    },
    getList(data) {
      this.tableLoading = true
      // this.clearSelection()
      if (this.page == this.PAGE_TYPE.MCAF){
        // 明察暗访
        this.clearEmptyMcafData(this.getMacfParams)
        // let params=this.getMacfParams
        // params.desc=this.mcafSort.desc
        // if(this.formInline.status!= null){
        //   params.status=this.formInline.status
        // }
        getMcafList(this.getMacfParams)
        .then(res => {
          this.pagination.total = res.data.totalElements
          // this.tableList = res.data.data.records
          // let sort={}
          // if(this.getParams.ascs){
          //   sort={property:this.getParams.ascs[0],type:'ascs'}
          // }else{
          //   sort={property:this.getParams.descs[0],type:'descs'}
          // }
          // const list =this.tableList.sort(this.compare(sort.property,sort.type))
          // console.log(list,'222')
          // this.tableData=list.slice((this.getParams.current-1)*20,20)
          this.tableData=res.data.content
          this.tableLoading = false
        })
        .catch(err => {
          this.tableLoading = false
          this.$message.error(err.msg || '获取失败，稍后重试')
        })
        .finally(() => {
          this.$refs.tabelContent?.doLayout()
        })
      }else if (this.page != this.PAGE_TYPE.RECYCLED) {
        //非回收站非明察暗访
        this.clearEmptyData(this.getParams)
        if (!data) {
          localStorage.setItem(
            'wj_list_history',
            JSON.stringify(
              Object.assign(
                {},
                { searchParams: this.getParams },
                {
                  username: this.userInfo.username,
                  companyId: this.companyId,
                  pageType: this.page
                }
              )
            )
          )
        }
        getQuestionList((data && data.searchParams) || this.getParams)
          .then(res => {
            this.pagination.total = res.data.data.total
            // const shareWjAccess = {
            //   'isSeeEdit':true, // 问卷编辑
            //   'isLogicWxRed':true, // 问卷设置
            //   'isNetworkAgent':true, //问卷发布
            //   'isExamineControl':true, // 问卷回收
            //   'isStatistics':true, // 数据分析
            //   'isExpenseSettlement':true, // 费用结算
            // }
            const shareWjAccess = [true, true, true, true, true, true]
            // const shareWjAccess = null

            // res.data.data.records.forEach(it => {
            //   if (it.shareWjAccess !== null) {
            //     const shareWjAccess = []
            //     shareWjAccess.push({ key: 'isSeeEdit', value: it.shareWjAccess.find(it => it.key === 'isSeeEdit').value })
            //     shareWjAccess.push({ key: 'isLogicWxRed', value: it.shareWjAccess.find(it => it.key === 'isLogicWxRed').value })
            //     shareWjAccess.push({
            //       key: 'isNetworkAgent',
            //       value: it.shareWjAccess.find(it => it.key === 'isNetworkAgent').value
            //     })
            //     shareWjAccess.push({
            //       key: 'isExamineControl',
            //       value: it.shareWjAccess.find(it => it.key === 'isExamineControl').value
            //     })
            //     shareWjAccess.push({ key: 'isStatistics', value: it.shareWjAccess.find(it => it.key === 'isStatistics').value })
            //     shareWjAccess.push({
            //       key: 'isExpenseSettlement',
            //       value: it.shareWjAccess.find(it => it.key === 'isExpenseSettlement').value
            //     })
            //     it.shareWjAccess = shareWjAccess
            //   }
            // })
            this.tableData = res.data.data.records //.map(it=> ({...it,internalShare:false,shareWjAccess}))
            this.tableLoading = false
            if (data) {
              this.pagination.current = data.searchParams.current
              this.pagination.size = data.searchParams.size
              this.handleTableScrollTop(data.scrollTop)
            }
          })
          .catch(err => {
            this.tableLoading = false
            this.$message.error(err.msg || '获取失败，稍后重试')
          })
          .finally(() => {
            this.$refs.tabelContent?.doLayout()
          })
      } else {
        //回收站
        this.clearEmptyData(this.getParamsRecycle)
        getRecycleList(this.getParamsRecycle)
          .then(res => {
            this.pagination.total = res.data.data.total
            this.tableData = res.data.data.records
            this.tableLoading = false
            // this.handleSelected(this.selectedItems);
          })
          .catch(err => {
            this.$message.error(err.msg || '获取失败，稍后重试')
          })
          .finally(() => {
            this.$refs.tabelContent?.doLayout()
          })
      }
    },
    // getList(params) {
    //   this.tableLoading = true
    //   }).catch(err => {
    //     this.$message.error("获取失败，稍后重试")
    //   }).finally(() => {
    //     this.tableLoading = false
    //   })
    // },
    async initSurveyGroups() {
      const surveyGroupsBak = [
        {
          groupName: '未分组',
          id: null
        }
      ]
      let result = await getSurveyGroups()
      if (!(result && result.data && result.data.data && Array.isArray(result.data.data))) {
        return false
      }
      this.surveyGroups = []
      this.surveyGroups = surveyGroupsBak.concat(
        result.data.data.map(it => {
          return it
        })
      )
    },
    isShowMoveMenu(item, row) {
      return item.id !== row.groupId
    },
    sortChange(params) {
      const ORDER = {
        ascending: 'ascs', // 升序
        descending: 'descs' // 降序
      }
      const transformProp = prop => {
        return prop.replace(/([A-Z])/g, '_$1').toLowerCase()
      }
      this.sortParams = {}
      this.mcafSort = {}
      // mcafSort:{sortField:'createdAt',desc:true},
      if (params.order) {
        this.sortParams[ORDER[params.order]] =
          params.prop == 'answerRecoveryAmount' ? [params.prop] : [transformProp(params.prop)]
        // 明察暗访排序
        this.mcafSort={sortField:params.prop,desc:params.order=='descending'?true:false}
      } else {
        //没有点击排序时
        this.page != this.PAGE_TYPE.RECYCLED && (this.sortParams.descs = ['is_star', 'create_time'])
        this.page == this.PAGE_TYPE.RECYCLED && (this.sortParams.descs = ['del_time']) //回收站
        // 明察暗访排序
        this.mcafSort={sortField:'createdAt',desc:true}
      }
      this.pagination.current = 1
      this.getList()
    },
    // copyId(row, column, event, cell) {
    //   if (this.page == this.PAGE_TYPE.RECYCLED) return
    //   let input = document.createElement('input')
    //   input.setAttribute('readonly', 'readonly')
    //   input.setAttribute('value', row.id)
    //   document.body.appendChild(input)
    //   input.select()
    //   if (document.execCommand('copy') && column.label == '问卷ID') {
    //     document.execCommand('copy')
    //     this.$message({
    //       message: '复制成功',
    //       type: 'success',
    //       center: true
    //     })
    //   }
    //   document.body.removeChild(input)
    // },
    handleTableScrollTop(top = 0) {
      //表格滚动条位置处理
      this.$nextTick(() => {
        const tc = this.$refs.tabelContent
        if (tc && tc?.bodyWrapper) {
          tc.bodyWrapper.scrollTop = top
        }
      })
    },
    // 点击 每页显示条数 触发
    sizeChange(val) {
      this.pagination.current = 1
      this.pagination.size = val
      this.handleTableScrollTop()
      this.getList()
    },
    // 切换页面
    currentChange(val) {
      this.pagination.current = val
      this.handleTableScrollTop()
      this.getList()
    },
    //表格的全选（回收站）
    // changeTableSelect(val) {
    //   if (val) {
    //     this.clearSelection()
    //     this.$refs.tabelContent.toggleAllSelection()
    //   } else {
    //     this.clearSelection()
    //   }
    //   if (!this.tableData.length) return
    //   this.isAll = val
    // },

    changeTableSelect(val) {
      if (val) {
        this.clearSelection()
        this.$refs.tabelContent.toggleAllSelection()
      } else {
        this.clearSelection()
        this.checkAll = false
      }
    },
    onCheckedChange(val) {
      if (val) {
        this.clearSelection()
        this.$refs.tabelContent.toggleAllSelection()
      } else {
        this.clearSelection()
      }
      if (!this.tableData.length) return
      this.checkAll = val
    },
    goSurveyLink(row) {
      setStore({ name: 'shareWjAccess', content: row.shareWjAccess ? row.shareWjAccess.map(it => it.value) : null })
      if (row.shareWjAccess === null) {
        this.jumpUrl(row.id,`/edit?scene=${row.sceneValue}`)
      } else {
        const shareWjAccess = row.shareWjAccess.filter(it => it.value).map(it => it.key)
        if (!shareWjAccess.length) {
          return
        }
        const firstKey = shareWjAccess[0]
        switch (firstKey) {
          case "isSeeEdit":
            this.jumpUrl(row.id,`/edit?scene=${row.sceneValue}`)
            break
          case "isLogicWxRed":
            this.jumpUrl(row.id, `/settings/jump-logic?scene=${row.sceneValue}`)
            break
          case "isNetworkAgent":
            this.jumpUrl(row.id, `/publish/link-qrcode?scene=${row.sceneValue}`)
            break
          case "isExamineControl":
            this.jumpUrl(row.id, `/data/data-examine/pending-review?scene=${row.sceneValue}`)
            break
          case "isStatistics":
            this.jumpUrl(row.id, `/analysis/statistical-charts?scene=${row.sceneValue}`)
            break
          case "isExpenseSettlement":
            this.jumpUrl(row.id, `/settlement/settlement-network/answer?scene=${row.sceneValue}`)
            break
          case "shareReport":
            this.jumpUrl(row.id, `/ai-report?scene=${row.sceneValue}`)
            break
          default:
            break
        }
      }
    },

    closePop(scope) {
      this.$refs[`popover-${scope.$index}`].doClose()
    },
    getVersionAllSimple(id) {
      getVersionAllSimple(id)
        .then(res => {
          this.lastReleaseVersion = {}
          this.historyVersions = []
          this.lastDraftVersion = {}

          const { lastDraftVersion, lastReleaseVersion, historyVersions } = res.data.data

          if (lastDraftVersion) {
            this.lastDraftVersion = lastDraftVersion
            console.log('lastDraftVersion', this.lastDraftVersion.sentisiveReason)
          }

          // 最新版
          if (lastReleaseVersion) {
            this.lastReleaseVersion = lastReleaseVersion
            console.log(this.lastReleaseVersion)
          }

          // 历史版本
          if (historyVersions && historyVersions.length !== 0) {
            this.historyVersions = historyVersions
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    surveyStatusTextFun(publishStatus) {
      if (publishStatus === this.SURVEY_PUBLISH_STATUS.UNPUBLISHED) {
        // 状态为未发布 对应按钮为发布
        return '发布'
      } else if (publishStatus === this.SURVEY_PUBLISH_STATUS.RECYCLING) {
        // 状态为回收中 对应按钮为关闭
        return '关闭'
      } else if (publishStatus === this.SURVEY_PUBLISH_STATUS.CLOSED) {
        // 状态为关闭 对应按钮为开启
        return '开启'
      }
    },
    // 问卷功能--发布/关闭/开启
    openCloseMethod(row, scope) {
      if(this.page == this.PAGE_TYPE.MCAF){
        this.publishMcaf(row, scope)
        return
      }
      setStore({ name: 'shareWjAccess', content: row.shareWjAccess ? row.shareWjAccess.map(it => it.value) : null })
      if (row.publishStatus === 0) {
        // 发布
        this.publishMethod(row)
      } else if (row.publishStatus === 2) {
        // 关闭
        // this.closeVisible = true
        this.closewjId = row.id
        this.sureClose(scope)
      } else if (row.publishStatus === 1) {
        // 开启
        openAllWj(new Array(row.id))
          .then(res => {
            if (res.status == 200) {
              this.$message({
                type: 'success',
                message: '开启成功!'
              })
            }
            this.$refs[`popover-${scope.$index}`].doClose()
            this.getList()
          })
          .catch(e => {
            this.$message({
              type: 'error',
              message: '开启失败!'
            })
            this.$refs[`popover-${scope.$index}`].doClose()
            throw new Error(e)
          })
      }
    },
    // 发布
    async publishMethod(row) {
      // 先校验有无添加题
      const res = await getSurveyById(row.id)
      const pageQuestions = res.data.data.pageQuestions

      if (!pageQuestions || pageQuestions.length === 0) {
        this.$message({
          type: 'warning',
          message: '请先去添加题型'
        })

        this.jumpUrl(row.id, `/edit?scene=${row.sceneValue}`)
        return
      }

      this.publishQuestion(row.id, row.title, true) // 问卷列表 发布时 忽略弹窗
        .then(() => {
          this.jumpUrl(row.id, '/publish/link-qrcode')
        })
        .catch(e => {
          // 为防止其他操作没有敏感词的 弹敏感词弹窗
          if (!e) return
          GlobalConfig.setSurveyId(row.id)
          this.sensitiveData = e
          this.sensitiveShow = true
        })
    },
    handleDelete(rowId) {
      let ids
      if (rowId) {
        ids = [rowId]
      } else {
        if (this.isAll) {
          ids = []
        } else {
          ids = this.selectedItems
            .map(it => ({ id: it.id }))
            .map(it => Object.values(it))
            .flat()
        }
      }
      if (rowId || (ids && ids.length > 0) || this.isAll) {
        batchDeleteWj({
          selectedIds: ids,
          query: this.getParamsRecycle
        }).then(res => {
          if (res.data.code === 0) {
            this.getList()
            this.clearSelection()
            this.$message.success('删除成功')
          } else {
            this.$message.warning(res.data.msg || res.data.data)
          }
        })
      } else {
        this.$message({
          type: 'error',
          message: '请先选择要删除的数据'
        })
      }
    },
    allDelete() {
      this.handleDelete()
    },
    removeList(row) {
      this.handleDelete(row.id)
    },
    // 管理or编辑明察暗访
    handleMcaf(row){
      // console.log(process.env.VUE_APP_MCAF_DOMAIN_NEW,'000')
      // return
      // if(!row.status){
        // 管理
        getMcafUrl(row.id).then(res=>{
          let url=process.env.VUE_APP_MCAF_DOMAIN_NEW + res.data.value.url.url
          url=url.replace('$appId',row.id)
          url=url.replace('$token',GlobalConfig.getBaseToken())
          window.open(url)
        })
      // }else{
      //   //编辑
      //   let url=`${process.env.VUE_APP_MCAF_DOMAIN_NEW}/cp/pl-dygc/create_project?token=${GlobalConfig.getBaseToken()}&comp=cp_createPro`
      //   window.open(url)
      // }
    },

    // 发布明察暗访
    publishMcaf(row, scope){
      let data = {status:row.status===1?0:1}
      updataMcaf(row.id,data).then(res => {
        if (res.status == 200) {
          this.$message({
            type: 'success',
            message: data.status===0?'关闭成功!':'开启成功!'
          })
        }
        this.$refs[`popover-${scope.$index}`].doClose()
        this.getList()
      })
      .catch(e => {
        this.$message({
          type: 'error',
            message: status===0?'关闭失败!':'开启失败!'
        })
        this.$refs[`popover-${scope.$index}`].doClose()
        throw new Error(e)
      })
    },
    // 删除明察暗访
    deleteMcaf(row){
      deleteMcafPro(row.id).then(res=>{
        if (res.data.status === 200) {
          this.getList()
          this.$message.success('删除成功')
        } else {
          this.$message.warning(res.data.msg || res.data.data)
        }
      })
    },
    // 获取项目类型数据源
    getProjectListData(){
      wjSceneTypeListAll().then(res => {
       if(res.data.code === 0){
        this.projectListData = res.data.data.filter(item=>{
          return item.label!='明察暗访'
        })
       }
      })
    }
  },
  beforeDestroy() {
    if (this.page != this.PAGE_TYPE.RECYCLED) {
      const savedData = JSON.parse(localStorage.getItem('wj_list_history'))
      savedData.scrollTop = this.tableScrollTop
      //监听的表格组件scrollTop值存在localStorage
      localStorage.setItem('wj_list_history', JSON.stringify(savedData))
    }
  }
}
